import HerramientasTemplate from "../../components/templates/clientes/HerramientasTemplate"

const Herramientas = () => {
    return <HerramientasTemplate/>;
};

export default Herramientas;